import $ from 'jquery';
import '../vendor/slick-carousel/slick.fix';

const defaults = {
  autoplay: true,
  speed: 2000,
  dots: true,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  slide: '.views-row',
  responsive: [
    {
      breakpoint: 1366,
      settings: {
        arrows: false,
      },
    },
  ],
};

function SpotlightSlider(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.slider = this.build();
  this.ready();
}

SpotlightSlider.prototype = {
  build() {
    return this.$element.find('.view-content').slick(this.settings);
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default SpotlightSlider;



// WEBPACK FOOTER //
// ./SpotlightSlider.js